var key_name = "MonId";
var key_name1= "ajam1";
var key_value = "9999";
    
/* set searchparams & update */
    export function setParam(key_name,key_value){
        var searchParams = new URLSearchParams(window.location.search)
        searchParams.set(key_name,key_value);

        var newSearchParams = window.location.pathname + '?' +         
            // manually create searchParams.search
            searchParams  // .toString() don't use: %20 > +
            .entries().toArray()// get entries and make array
            .map(m=>`${encodeURIComponent(m[0])}=${encodeURIComponent(m[1])}`).join("&") // recreate searchParams.search
        history.pushState(null, '', newSearchParams); // reapply to url
    }
/* append searchparams & update */
    export function appendParam(key_name,key_value){
        var searchParams = new URLSearchParams(window.location.search)
        searchParams.append(key_name,key_value);
        var newSearchParams = window.location.pathname + '?' +         
            // manually create searchParams.search
            searchParams  
            // don't use .toString(): %20 > + wrong encoding
            .entries().toArray()// get entries and make array
            .map(m=>JSON.stringify(m)).filter((f,i,a)=>a.indexOf(f)==i).map(m=>JSON.parse(m)) // remove doublicates
            .map(m=>`${encodeURIComponent(m[0])}=${encodeURIComponent(m[1])}`).join("&") // recreate searchParams.search
        history.pushState(null, '', newSearchParams); // reapply to url
    }    
/* remove searchparams & update */
    export function removeParam(key_name,key_value){ console.log(key_name,key_value)
        var searchParams = new URLSearchParams(window.location.search)
        // searchParams.append(key_name,key_value);
        var newSearchParams = window.location.pathname + '?' + searchParams
            .entries().toArray() // get all entries and make array  
            .map(m=>JSON.stringify(m)).filter((f,i,a)=>a.indexOf(f)==i).map(m=>JSON.parse(m)) // remove doublicates
            .filter(f=>(f[0]==key_name && f[1]==key_value)?false:true) // remove [key_name,key_value]
            .map(m=>`${encodeURIComponent(m[0])}=${encodeURIComponent(m[1])}`) 
            .join("&") // recreate searchParms.search
        console.log(newSearchParams)
        history.pushState(null, '', newSearchParams); // reapply to url
    }    
/* get searchparams */    
    export function getParam(key_name){
        var searchParams = new URLSearchParams(window.location.search)
        return searchParams.get(key_name);        
    }

/* getAll searchparams */    
    export function getAllParam(key_name){
        var searchParams = new URLSearchParams(window.location.search)
        return searchParams.getAll(key_name);        
    }

/* delete searchparams & update */
    export function delParam(key_name){
        var searchParams = new URLSearchParams(window.location.search)
        searchParams.delete(key_name);
        var newSearchParams = window.location.pathname + '?' +         
            // manually create searchParams.search
            searchParams
            // don't use .toString(): %20 > + wrong encoding
            .entries().toArray()// get entries and make array
            .map(m=>`${encodeURIComponent(m[0])}=${encodeURIComponent(m[1])}`).join("&") // recreate searchParams.search
        history.pushState(null, '', newSearchParams); // reapply to url
    }
/* {
    setParam,
    getParam,
    getAllParam,
    delParam

    appendParam,
    removeParam,        
    }
*/
// {setParam,appendParam,removeParam,getParam,getAllParam,delParam}

// ;(()=>{
//     var searchParams = new URLSearchParams(window.location.search)
//     searchParams.set("ajam","ajam")
//     searchParams.set("ajam1","ajam1")
//     searchParams.append("ajam1","ajam11")
//     console.log(
//     searchParams.set(key_name,key_value),
        
//     searchParams.get(key_name),
//     searchParams.getAll(key_name1),//.toArray(), // if key_name has multiple values
        
//     searchParams.append(key_name,key_value),
//     searchParams.delete(key_name),
//     searchParams.has(key_name),
        
//     searchParams.size,    
//     searchParams.forEach((key,value)=>console.log(key,value)),
    
    
//     searchParams.sort(),
//     searchParams.toString(),
        
//     searchParams.keys().toArray(),
//     searchParams.values().toArray(),
//     searchParams.entries().toArray(), // convert iterator to array
//     )
// })()